export const convertStringToParagraphs = (text: string) => {
  return text.split('. ').join('.\n').trim();
};
